import { ControllerBase, modules } from "./base";

export class CrudBase extends ControllerBase {
    formLayout = [];
    formData = null;
    defaultModel = null;

    list = []
    headers = [];
    item = {};
    name = "";

    actions = {
        getAll: null,
        getSingle: null,
        create: null,
        update: null,
        delete: null
    }

    routes = {
        list: null,
        create: null,
        edit: null
    }

    sections = {
    }

    constructor(options = params) {
        super({
            modules: {
                ...options.modules
            },
            required_modules: {
                crud: true
            },
        })

        this.name = options.name;

        if (options.model != null) {
            this.defaultModel = options.model;
            this.formData = new this.defaultModel();
            this.item = new this.defaultModel();
        }

        this.headers = require(`../config/headers/${options.name}.json`);
        this.formLayout = require(`../config/form/${options.name}.json`);

        // OVERRIDE THE ROUTES IF NEED BE
        this.routes = {
            list: `/${options.name}`,
            create: `/${options.name}/create`,
            edit: `/${options.name}/edit/`,
        }
    }

    // CRUD METHODS

    async submit() {
        await this.create();
    }

    async execute(action, request, queryParams) {
        this.loading = true;
        try {
            let response = await this.crud.query(action, request, queryParams);

            this.loading = false;

            return response;
        } catch (error) {
            this.loading = false;
            return error;
        }
    }

    async getAll() {
        this.loading = true;
        let response = await this.crud.getAll(this.actions.getAll);
        this.list = this.defaultModel.toList(response);
        this.loading = false;
    }

    async getById(id) {
        this.loading = true;
        let response = await this.crud.getById(this.actions.getSingle, null, `?id=${id}`);
        this.formData = new this.defaultModel(response.data);
        this.loading = false;
    }

    async create() {
        this.loading = true;

        try {
            let response = await this.crud.create(this.actions.create, this.formData);
            this.list.push(new this.defaultModel(response))

            this.app.$router.back();
            this.loading = false;
            return response;
        }
        catch (err) {
            this.loading = false;
            console.log(err);
        }
    }

    async update(item) {
        this.loading = true;

        try {
            await this.crud.update(this.actions.update, item, `?id=${item.id}`);
            this.loading = false;
        }
        catch (err) {
            this.loading = false;
            console.log(err);
        }
    }

    async delete(item) {
        try {
            await this.crud.delete(this.actions.delete, null, `?id=${item.id}`);
            this.list.splice(this.list.indexOf(item), 1);
        }
        catch (err) {
            console.log(err);
        }
    }

    // UI HOOKS
    onAdd() {
        this.formData = new this.defaultModel();
        this.app.$router.push(this.routes.create);
    }

    onEdit(item) {
        this.app.$router.push(`${this.routes.edit}${item.id}`);
    }

    onCancel() {
        this.app.$router.push(this.routes.list);
    }
}

export class CrudSection {
    ctrl = null;

    constructor(ctrl) {
        this.ctrl = ctrl;
    }
}

const params = {
    name: null,
    modules: {
        ...modules
    },
    actions: {
        getAll: null,
        getByID: null,
        create: null,
        update: null,
        delete: null
    },
    model: null
}